import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import getPictureUrl from 'utils/image/getPictureUrl';
import createLocation from 'utils/createLocation';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
function formatData(props) {
  var _asset$tags;
  var asset = props.asset,
    origin = props.origin;
  var isHub = origin === 'hub';
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  var playlists = asset.parentPlaylists.map(function (_ref) {
    var id = _ref.id,
      name = _ref.name,
      thumbnailId = _ref.thumbnailId;
    return {
      id: id,
      title: name,
      pictureUrl: getPictureUrl({
        id: thumbnailId
      }),
      location: isPlaylistAdmin || isHub ? {
        pathname: "/playlists/".concat(id),
        search: '',
        state: undefined,
        hash: ''
      } : ''
    };
  });
  var tags = (_asset$tags = asset.tags) === null || _asset$tags === void 0 ? void 0 : _asset$tags.map(function (tag) {
    var id = tag.id,
      name = tag.name;
    var hubTagsLocation = createLocation('/search', {
      term: "tag:\"".concat(name, "\"")
    });
    var adminTagsLocation = createLocation('/assets', {
      search: "tags:\"".concat(name || tag, "\"")
    });
    var location = isHub ? hubTagsLocation : adminTagsLocation;
    return {
      id: id,
      title: name,
      location: location
    };
  });
  return {
    playlists: playlists,
    tags: tags
  };
}
export default formatData;